import { ILocation, Location } from "@harlowe/core";

export interface ICompany
{
    name: string;
    tier: number;
    parent?: ICompany;
    companyLocation?: ILocation;
}

export class Company implements ICompany
{
    constructor
    (
        public id: number,
        public name: string,
        public tier: number,
        public parent?: ICompany,
    )
    {
    }

    companyLocation?: Location; 
}

export interface ICarrier extends ICompany
{
    billingEmailAddress?: string;
}

export class Carrier extends Company implements ICarrier 
{
    constructor(id:number, name:string)
    {
        super(id, name, 1)
    }   

    billingEmailAddress?: string;
}

export class CarrierInsert
{
    constructor
    (
        public name: string
    )
    {
    }

    static create(carrier: ICarrier, locationId?: number, billingEmailAddress?: string) : CarrierInsert
    {
        var c = new CarrierInsert(carrier.name);
        c.companyLocationId = locationId;
        c.billingEmailAddress = billingEmailAddress;
        return c;
    }

    companyLocationId?: number;
    billingEmailAddress?: string;
}

export class CarrierUpdate
{
    constructor
    (

    )
    {}

    static create(carrier: ICarrier, locationId?: number, billingEmailAddress?: string) : CarrierUpdate
    {
        var c = new CarrierUpdate();
        c.companyLocationId = locationId;
        c.name = carrier.name;
        c.billingEmailAddress = billingEmailAddress;
        return c;
    }

    name?: string;
    companyLocationId?: number;
    billingEmailAddress? :string;
}
